module.exports = __webpack_public_path__ + "static/media/visa-photo-upload.4bd09461.png";